import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { TabsetComponent } from 'ng-uikit-pro-standard';
import { forkJoin, of, throwError } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApirequestService } from 'src/app/api/request/apirequest.service';
import { ApiFunctions } from 'src/app/shared/functions/api-functions';
import { DateFormats } from 'src/app/shared/functions/date-formats';
import { FormFunctions } from 'src/app/shared/functions/form-functions';
import { PGAUtils } from 'src/app/shared/functions/pga-utils';
import { DeliveryNoteInterface } from 'src/app/shared/interfaces/data/delivery-note-interface';
import { DropdownsInterface } from 'src/app/shared/interfaces/data/dropdowns-interface';
import { FirmAddressInterface } from 'src/app/shared/interfaces/data/firm-address-interface';
import { InvoiceproformaInterface } from 'src/app/shared/interfaces/data/invoiceproforma-interface';
import { LockdataInterface } from 'src/app/shared/interfaces/data/lockdata-interface';
import { TabParamsInterface } from 'src/app/shared/interfaces/tab-params/tab-params-interface';
import { DetailLinesComponent } from '../../components/detail-lines/detail-lines.component';
import { ActionButtonsService } from '../../services/action-buttons.service';
import { LockService } from '../../services/lock.service';
import { NotificationService } from '../../services/notification.service';
import { Tab } from '../../tab-models/tab.model';
import { EntityService } from '../../services/entity.service';
import { catchError } from 'rxjs/operators';
import { DropdownService } from '../../services/dropdown.service';

@Component({
  selector: 'app-invoiceproforma',
  templateUrl: './invoiceproforma.component.html',
  styleUrls: ['./invoiceproforma.component.scss']
})
export class InvoiceproformaComponent implements OnInit {

  @Input() tab: Tab;
  @Input() data: TabParamsInterface;

  @ViewChild('invoiceproformaTabs', { static: true }) invoiceproformaTabs: TabsetComponent;
  @ViewChild('detailComponent', {static: false}) detailComponent: DetailLinesComponent



  public id: number;
  public dropdowndata
  public loading = false;
  public invoiceproforma: InvoiceproformaInterface;
  private formFunctions = new FormFunctions;

  public detail: Array<any>;

  private utils = new PGAUtils;

  public firm_addresses: Array<FirmAddressInterface>;

  private subscriptions: Array<Subscription> = [];

  public dateFormatter = new DateFormats;

  public formInvoiceproforma: FormGroup;

  public detail_headers: Array<any> = [
    {header: 'Exp.', class: 'buttons-column'},
    {header: 'Código', class: 'code-column'},
    'Descripción',
    { header: 'Cantidad', class: 'numbers-column'},
    {header: 'Precio', class: 'numbers-column'},
    {header:'%Descuento', class: 'percent-column'},
    {header:'%Impuesto', class: 'percent-column'}
  ]
  public detail_fields_order: Array<any> = [
    {
      control: 'type_export_line_id',
      type: 'checkbox',
      default:  0,
      disabled: false
    },
    {
      control: 'code',
      type: 'text',
      default: '',
      disabled: false,
      addKey: true
    },
    {
      control: 'description',
      type: 'text',
      default: '',
      disabled: false,
      validate:true,
      validators:[Validators.required],
      error_msg: 'Campo obligatorio',
      addKey: true,
    },
    {
      control: 'quantity',
      type: 'number',
      default: 1,
      disabled: false,
      validate: true,
      validators: [Validators.required],
      error_msg: 'Campo obligatorio'
    },
    {
      control: 'price',
      type: 'number',
      disabled: false,
      default: 0,
      validate: true,
      validators: [Validators.required],
      error_msg: 'Campo obligatorio'
    },
    {
      control: 'discount',
      type: 'number',
      disabled: false,
      default: 0,
      validate: true,
      validators: [Validators.required],
      error_msg: 'Campo obligatorio'
    },
    {
      control: 'taxe_id',
      type: 'select',
      dropdown: 'taxes',
      field_value: 'value',
      addKey: true,
      clear: false,
      listen_changes: true,
      disabled: false,
      default: 1,
    }
  ]


  private unlock_subscription: Subscription;
  private lockdata: LockdataInterface;

  public claim_entity = this._entity.entities.claim;
  public client_entity = this._entity.entities.client;
  public guild_entity = this._entity.entities.guild;
  public serie_entity = this._entity.entities.serie;

  constructor(private _api: ApirequestService, private _lock: LockService, private _apifunctions: ApiFunctions, private _buttons: ActionButtonsService, private _notification: NotificationService, private _entity: EntityService,  private _dropdowns: DropdownService) { }

  ngOnInit(): void {
    this.id = +this.data.id;
    this.formInvoiceproforma = this.formFunctions.getForm(this.data.entity);
    this.getData();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll()

    this._api.unlockExit(this.lockdata)
  }
  unsubscribeAll(){
    for(let i=0;i<this.subscriptions.length;i++){
      this.subscriptions[i].unsubscribe();
    }

  }

  private getData() {
    this.loading = true;
    this.detailComponent?.detailsForms.clear();

    this.subscriptions.push(
      forkJoin([
        this._api.get(this.data.saveEndpoint + '/' + this.id),
        this._dropdowns.getDropdownsAPI_Observable(this.data.edit_register_dropdowns)
      ])
      .pipe(
        catchError(error => {
          this.loading = false;
          return throwError(error)
        })
      )
      .subscribe(
        responses => {
          this.checkLock(responses.find(response => response.response.hasOwnProperty(this.data.entity)).response)
          this.setDropdowns()

          this.loading = false;
        },
        error => {
          console.log(error)
          this.loading = false;
        }
      )
    );
  }

  private setFirmAddresses(){
    this.loading = true;
    let newurl = new URL(this._api.getAPIEndpoint()+'firmsaddresses');
    let filter_firm = {
      firmaddress: {
        firm_id: this.invoiceproforma.firm_id
      }
    }

    newurl.searchParams.append('filters', JSON.stringify(filter_firm));
    newurl.searchParams.append('paginate', JSON.stringify(0));

    this.subscriptions.push(
      this._api.get('firmsaddresses'+newurl.search).subscribe(
        response => {
          this.dropdowndata['firm_addresses'] = response.response.firmaddress;
          this.loading = false;
        },
        error => {
          this.loading = false;
        }
      )
    );
  }

  private setDropdowns() {
    let data = this.utils.objectDeepCopy(this._dropdowns.getDropdownsObject(this.data.edit_register_dropdowns));
    data.guild = data.guild.filter(guild => guild.enabled == true);
    this.dropdowndata = data;
  }

  private checkLock(apiresponse: any): void {
    this.lockdata = this._lock.fillLockdata(apiresponse.lock)
    this.invoiceproforma = apiresponse.invoiceproforma;
    this.detail = apiresponse.invoiceproforma.lines;

    this.setFirmAddresses()

    this.tab.tabData.headerData = this.invoiceproforma.number;


    console.log(this.lockdata)

    if(!this.lockdata.unblock) {
      this.tab.tabLock = true;
      if(this.tab.tabActive) {
        this.openLockModal()
      }
    } else {
      this.setFormData()
    }
  }

  public openLockModal(){
    this._lock.showLockModal(this.lockdata);

    this.unlock_subscription = this._lock.confirmUnblock.subscribe(
      lockdata =>{
        if(lockdata) {
          this.lockdata = this._lock.fillLockdata(lockdata)
          this.tab.tabLock = false;
          this.formInvoiceproforma = undefined;
          setTimeout(() => {
            this.formInvoiceproforma = this.formFunctions.getForm(this.data.entity);
            this.setFormData();
          },5)
        } else{
          this.setFormData(true)
        }

        this.unlock_subscription.unsubscribe()
      }
    );
  }

  private setFormData(block?: boolean) {
    if(block){
      this.formFunctions.rellenarFormulario(this.formInvoiceproforma, this.invoiceproforma);
      this.setInvoiceproformaAddress();
      this.setInvoiceProformaProviderName();
      this.formInvoiceproforma.disable();
    } else {
      this.formFunctions.rellenarFormulario(this.formInvoiceproforma, this.invoiceproforma);

      this.setInvoiceproformaAddress();
      this.setInvoiceProformaProviderName();
      this.formInvoiceproforma.controls.emission_date.setValue(this.dateFormatter.cambioFormato(this.invoiceproforma.emission_date));

      this.subscriptions.push(
        this.formInvoiceproforma.valueChanges.subscribe(
          change => {
            this.tab.modifiedData = true;
          }
        )
      )
    }
  }

  private setInvoiceproformaAddress() {
    let address = '';

    if(this.invoiceproforma.claim) {
      if(this.invoiceproforma.claim?.policy) {
        address = this.invoiceproforma.claim.policy.address_complete;
      } else if(this.invoiceproforma.claim?.clientaddress) {
        address = this.invoiceproforma.claim.clientaddress.address_complete;
      }
    } else if(this.invoiceproforma.clientaddress_id) {
      address = this.invoiceproforma.clientaddress.address_complete;
    }

    this.formInvoiceproforma.controls.invoiceproforma_address.setValue(address);
  }

  private setInvoiceProformaProviderName() {
    let provider_name = 'Particular';
    if(this.invoiceproforma.provider) {
      provider_name = this.invoiceproforma.provider.name;
      if(this.invoiceproforma.subprovider) {
        provider_name += ' ('+this.invoiceproforma.subprovider.name+')';
      }
    }

    this.formInvoiceproforma.controls.invoiceproforma_provider_name.setValue(provider_name);
  }

  disableChanges(): boolean {
    let readonly = false;
    if(!this.lockdata?.unblock) {
      readonly = true;
    } else {
      if(this.invoiceproforma && this.invoiceproforma.typecondition_id == 2) {
        //deshabilitar = true;
      }
    }
    return readonly;
  }

  changeSelect(tipo: string, valor) :void{
    this.formInvoiceproforma.controls[tipo]['controls'].id.setValue(valor);
    this.formInvoiceproforma.controls[tipo]['controls'].id.markAsDirty();
  }

  onSubmit() {

    this._buttons.setLoading(true);

    this.formInvoiceproforma.markAllAsTouched();

    let line_form_error = false;
    this.detailComponent.detailsForms.controls.forEach(
      form => {
        form.markAllAsTouched();
      }
    )
    for (let index = 0; index < this.detailComponent.detailsForms.controls.length; index++) {
      if(this.detailComponent.detailsForms.controls[index].invalid) {
        line_form_error = true;
        break;
      }
    }


    if(this.formInvoiceproforma.valid && !line_form_error) {
      const params = {};

      //Datos F.Proforma
      this.formFunctions.fillFormParams(this.formInvoiceproforma, this.data.entity, params)

      //Datos Líneas
      params['invoiceproformalines']= [];
      this.detailComponent.pushDetailsToMaster(params['invoiceproformalines']);

      if(params['invoiceproformalines'].length > 0) {
        params[this.data.entity]['total'] = this.detailComponent.total_lineas
        params[this.data.entity]['total_price'] = this.detailComponent.total_price
        params[this.data.entity]['total_taxe'] = this.detailComponent.total_taxe
        params[this.data.entity]['total_cost'] = this.detailComponent.total_cost
      }

      this.subscriptions.push(
        this._api.put(this.data.saveEndpoint+'/'+this.data.id, JSON.stringify(params)).subscribe(
          resp=>{
            this.tab.modifiedData = false;
            this.formInvoiceproforma.markAsPristine();
            this.unsubscribeAll()
            this.getData();
            this._buttons.reloadListTab(this.data.saveEndpoint)
            this._buttons.setLoading(false);
            this._notification.notificacionOK(resp.response[this.data.entity])
          },
          err => {
            this._buttons.setLoading(false);
          }
        )
      )
    } else {
      this._buttons.setLoading(false);
    }


  }
}
